export default "__VITE_ASSET__Bn9TGoyb__"